import { Component, inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PoBreadcrumb, PoModalComponent, PoStepperComponent, PoTableColumn, PoTableColumnSpacing, PoToasterType } from '@po-ui/ng-components';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-processamento-fichas-novo',
  templateUrl: './novo.component.html',
  styleUrls: ['./novo.component.css'],
  standalone: false
})
export class ProcessamentosFichasNovoComponent {
  tableItens: any[] = [];
  itensDetalhes: any[] = [];
  columns: Array<PoTableColumn> = [];
  columnsDetalhes: Array<PoTableColumn> = [];
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;

  isHideLoading = true;
  moreItens = false;
  page = 1;
  pageSize = 15;
  filter = '';
  disclaimerGroup: any;
  private disclaimers: any[] = [];
  tamanhoModal = 'xl';

  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/mascaras`;

  private httpClient = inject(HttpClient);

  constructor(private router: Router) {
    this.columns = this.getColumns();
  }

  @ViewChild('stepper', { static: true }) stepper!: PoStepperComponent;
  @ViewChild('clienteForm', { static: true }) clienteForm!: NgForm;
  @ViewChild('modalProcessamento', { static: true }) modalProcessamento!: PoModalComponent;

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Processamento Fichas', link: '/processamento-fichas' },
      { label: 'Novo Processamento' },
    ]
  };

  readonly clientesServiceUrl = `${environment.apiUrl}${environment.versionApi}${environment.clienteServiceApi}`;

  selectedCliente?: number;
  periodo = { ano: null as number | null, mes: null as number | null };
  periodoFinal = { ano: null as number | null, mes: null as number | null };
  cargaInicialOk = false;
  movimentacaoOk = false;
  cargaInicialOkMessage: string = '';
  movimentacaoOkMessage: string = '';
  cliente: any;

  nextLabelWidget = 'Próximo';
  previousLabelWidget = 'Voltar';

  type: PoToasterType = PoToasterType.Error;
  typeMov: PoToasterType = PoToasterType.Error;

  anos = Array.from({ length: 10 }, (_, i) => {
    const anoAtual = new Date().getFullYear();
    const value = anoAtual - i;
    return { label: value.toString(), value };
  });

  meses = [
    { label: 'Janeiro', value: '01' },
    { label: 'Fevereiro', value: '02' },
    { label: 'Março', value: '03' },
    { label: 'Abril', value: '04' },
    { label: 'Maio', value: '05' },
    { label: 'Junho', value: '06' },
    { label: 'Julho', value: '07' },
    { label: 'Agosto', value: '08' },
    { label: 'Setembro', value: '09' },
    { label: 'Outubro', value: '10' },
    { label: 'Novembro', value: '11' },
    { label: 'Dezembro', value: '12' }
  ];

  canActiveNextStepCliente = (): boolean => {
    return this.selectedCliente !== undefined;
  };

  canActiveNextStepPeriodo = (): boolean => {
    return !!this.periodo.ano && !!this.periodo.mes && !!this.periodoFinal.ano && !!this.periodoFinal.mes;
  };

  chageCliente(cliente: any) {
    this.selectedCliente = cliente;
    this.buscarCliente();
  }

  checkCargaInicial() {
    if (!this.selectedCliente) return;
    this.httpClient.post(`${environment.apiUrl}/v1/carga-inicial/validate/${this.selectedCliente}`, {})
      .subscribe({
        next: (res: any) => {
          this.cargaInicialOk = !!res.success;
          this.cargaInicialOkMessage = res.message;
          if (this.cargaInicialOk) {
            this.type = PoToasterType.Success;
          } else {
            this.type = PoToasterType.Warning;
          }
        },
        error: err => console.log('Carga inicial não realizada:', err)
      });
  }

  checkMovimentacao() {
    if (!this.selectedCliente || !this.periodo.ano || !this.periodo.mes) return;
    this.httpClient.post(`${environment.apiUrl}/v1/movimentacao/validate/${this.selectedCliente}/${this.periodo.mes}-${this.periodo.ano}`, {})
      .subscribe({
        next: (res: any) => {
          this.movimentacaoOk = !!res.success;
          this.movimentacaoOkMessage = res.message;
          if (this.movimentacaoOk) {
            this.typeMov = PoToasterType.Success;
          }
          else {
            this.typeMov = PoToasterType.Warning;
          }
        },
        error: err => console.log('Movimentação não realizada:', err)
      });
  }

  beforeNextStep(stepIndex: number): boolean {
    if (stepIndex === 0 && !this.canActiveNextStepCliente()) return false;
    if (stepIndex === 1 && !this.canActiveNextStepPeriodo()) return false;
    if (stepIndex === 1) {
      this.checkCargaInicial();
      this.checkMovimentacao();
      this.carregarMascaras();
      setTimeout(() => {
        return true;
      }, 1000);
    }
    if (stepIndex === 2 && (this.cargaInicialOk == false || this.movimentacaoOk == false)) return false;
    return true;
  }

  buscarCliente() {
    this.httpClient.get(`${environment.apiUrl}/v1/clientes/${this.selectedCliente}`, {})
      .subscribe({
        next: (res: any) => this.cliente = res,
        error: err => console.log('Cliente não encontrado', err)
      });
  }

  solicitarProcessamento() {
    this.httpClient.post(`${environment.apiUrl}/v1/modulo/calcula-modulos-lote-background`, {
      idCliente: this.selectedCliente,
      competenciaInicial: String(this.periodo.ano + '-' + this.periodo.mes),
      competenciaFinal: String(this.periodoFinal.ano + '-' + this.periodoFinal.mes)
    })
      .subscribe({
        next: (res: any) => this.modalProcessamento.open(),
        error: err => console.log('Cliente não encontrado', err)
      });
  }

  onConfirmModal() {
    this.router.navigate(['/processamento-fichas']);
  }

  carregarMascaras() {
    this.loadMore(true);
  }

  loadMore(reset: boolean = false): void {
    this.isHideLoading = false;
    if (reset) {
      this.page = 1;
      this.httpClient
        .get<any>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&IdCliente=${this.selectedCliente}`)
        .subscribe(
          data => {
            this.tableItens = [];
            this.tableItens = [...this.tableItens, ...data.items];
            this.moreItens = data.hasNext;
            this.page++;
            this.isHideLoading = true;
          },
          error => {
            console.log(error);
            this.isHideLoading = true;
          }
        );
    } else {
      this.httpClient
        .get<any>(`${this.serviceApi}?page=${this.page}&pageSize=${this.pageSize}&IdCliente=${this.selectedCliente}`)
        .subscribe(
          data => {
            this.tableItens = [...this.tableItens, ...data.items];
            this.moreItens = data.hasNext;
            this.page++;
            this.isHideLoading = true;
          },
          error => {
            console.log(error);
            this.isHideLoading = true;
          }
        );
    }
  }

  getColumns(): Array<PoTableColumn> {
    return [
      { property: 'hipotese_geracao', label: 'Hipótese', type: 'string' },
      { property: 'obs', label: 'Observação', type: 'string' },
      { property: 'ficha', label: 'Ficha', type: 'string' },
      { property: 'cfop_list', label: 'CFOP', type: 'string' },
      { property: 'cst_list', label: 'CST', type: 'string' },
      { property: 'predbc', label: 'Pred BC', type: 'string' },
      { property: 'picms', label: 'Pic MS', type: 'string' },
    ];
  }
}
